/* Copyright 2022- Martin Kufner */

import {QbMessage} from './qb-message'
import {QbElement} from '@qb-assets-js/qb-elements/qb-element';
import {PUT, GET} from "@qb-assets-js/qb-fetch"
import "@node/emoji-picker-element";


import emojiDataUrl from '@node/emoji-picker-element-data/en/emojibase/data.json?url';

self.emojiDataUrl = emojiDataUrl;
const chatConfettiRegex = /@(\p{Extended_Pictographic}|\p{Emoji_Presentation}|\p{Emoji}\uFE0F)/gu;


export class QbChat extends QbElement {
    static shadow = {mode: 'open', sheets: ["qb-elements"]};
    #input
    #scrollContainer
    #bottomContainer
    #emojiContainer

    constructor() {
        super();
        this.#bottomContainer = DIV({part: "bottom", beforeend: this.contentRoot},
            BUTTON({part: "open", data: {_title: "Open chat", _ariaLabel: "Open chat" }, ariaExpanded: "false",class: "open nobutton", events: [this, {click: "toggle"}]}, QbIcon("chat", {ariaHidden: true})),
            DIV({part: "open-container"},
                BUTTON({part: "send", data: { _ariaLabel: "Send message (or press Enter twice)", _title: "Send message (or press Enter twice)" }, class: "send nobutton", events: [this, {click: "send"}]}, QbIcon("send", {ariaHidden: true})),
                BUTTON({part: "emoji", data: {_title: "Insert emoji", _ariaLabel: "Insert emoji"}, class: "emoji nobutton", events: [this, {click: "emoji"}]}, QbIcon("emoji",{ ariaHidden: true })),
                SLOT({name: "input", part: "input"})
            ),
            DIV({part: "notice"})
        );
        this.#scrollContainer = DIV({part: "messages-scroll", beforeend: this.contentRoot}, SLOT({part: "messages"}));
        this.contentRoot.adoptStyleSheets("slots");
        // document.addEventListener("selectionchange", this, {passive: true});
        self.QbChat = this;
    }

    #pollInterval

    get init() {
        this.#input = TEXTAREA({
            // placeholder: _("Write your message"),
            required: true,
            class: 'input',
            slot: "input",
            data: {_ariaLabel: "Type your message", _placeholder: "Chat with us"},
            afterbegin: this,
            events: [this, 'input', 'beforeinput', 'keydown']
        });

        if(!this.#pollInterval) this.#poll;
    }



    get #poll() {
        const message_ids = [...this.querySelectorAll(".qb-message[itemid]")].map(n => n.itemid);
        PUT('/chats', {body: {message_ids, show_id: self.show_id, vendor_id: self.vendor_id, venue_id: self.venue_id}}).result({
            json: data => {
                 if(!self.RoomService?.connected) this.#pollInterval = setTimeout(() => this.#poll, 15000);
                data.messages.forEach(msg => this.#receiveMessage({itemtype: "Chat", ...msg}));
            },
            error: e => {
                console.error("HIER", e);
            }
        });
    }

    // set open(value) {
    //     setTimeout(() => this.querySelectorAll(".new-message").forEach(n => n.removeClass("new-message")), 5000);
    // }


    focus() {
        this.toggleClass('open');
        this.#input.focus();
        return this;
    }

    handleEvent_toggle(evt) {
        evt.stopImmediatePropagation();
        if(this.#sendMessage) return;
        this.removeClass('new-message');
        evt.currentTarget.ariaExpanded =  this.toggleClass('open');
    }

    handleEvent_emoji(e) {
        let node = this.shadowRoot.querySelector("qb-emoji-picker");
        if(node || !e) return node?.remove();
        node = cT("qb-emoji-picker", { part: 'picker', beforeend: this.shadowRoot });
        node.onemojiclick = e=>{
            // console.log(e.detail);
            this.insert(e.detail.unicode);
        }
    }

    get message_id() {
        const message_id = this.#input.itemid;
        if(message_id) return message_id;
        this.message_id = true;
        return this.#input.itemid;
    }

    set message_id(value) {
        if(typeof value !== "string") value = `${new Date().getTime()}_${self.user_id}`;
        this.#input.itemid = value;
    }

    set sender_id(value) {}

    get sender_id() {}

    set participants(value) {}

    get participants() {}

    set reactions(value) {}

    get reactions() {}

    handleEvent_keydown(evt) {
        switch(evt.key) {
            case 'Escape':
                return this.reset;
            case 'Enter':
                if(
                    evt.target.value.at(-1) != "\n" &&
                    !evt.shiftKey &&
                    !evt.ctrlKey &&
                    !evt.metaKey
                ) return;
                evt.preventDefault();
                return this.#sendMessage;
        }

    }

    handleEvent_send(evt) {
        this.#sendMessage;
    }

    handleEvent_beforeinput(evt) {
        let data;
        switch(evt.inputType) {
            case "insertFromDrop":
            case "insertFromPaste":
                data = evt.dataTransfer.getData("text/plain");
                // console.log(evt.currentTarget, data);
                evt.preventDefault();
                this.insert(data);
                return;
        }
    }

    handleEvent_input() {
        const textarea = this.#input;
        textarea.style.height = 'auto';
        textarea.style.height = (textarea.scrollHeight) + 'px';
        this.setClass(/\S/.test(textarea.value), "has-input");
    }

    get #sendMessage() {
        let itemtype = "Chat";
        if(chatConfettiRegex.test(this.message)) itemtype = "Reaction"
        const data = {
            message: this.message,
            itemid: this.message_id,
            itemtype
        };
        if(this.#input.id) data.reference = {itemid: this.#input.itemid, text: this.#input.dataset.reference};
        this.#input.removeClass("reply-message");
        this.#input.removeAttribute("itemid");
        delete this.#input.dataset.reference;
        if(!data.message) return false;
        this.receive(data);

        PUT('/chat', {body: {chat: data, show_id: self.show_id, vendor_id: self.vendor_id, venue_id: self.venue_id}}).result({
            json: data => {
                if(!self.inBusiness) {
                    const notice = this.#bottomContainer.querySelector("[part='notice']");
                    if(notice) notice.textContent = _(`Thanks for writing, we will answer during our office hours, 10:00-24:00 Paris Time`);
                }
                if(data.itemid instanceof Array) {
                    const [old_itemid, new_itemid] = data.itemid;
                    const old_node = this.querySelector(`[itemid="${old_itemid}"]`);
                    const new_node = this.querySelector(`[itemid="${new_itemid}"]`);
                    if(new_node) old_node?.remove();
                    else if(old_node) old_node.itemid = new_itemid;
                }
            }
        });
        this.reset;
        this.handleEvent_emoji(false);
        return true;
    }


    handleEvent_emojiClick(e) {
        this.insert(e.detail.unicode);
    }

    get reset() {
        this.#input.value = "";
        this.#input.style.height = '';
        this.message_id = null;
        this.#input.removeClass("edit-message", "reply-message");
        this.handleEvent_input();
        this.handleEvent_emoji();
    }

    edit(text, message) {
        this.reset;
        this.#replace(text);
        this.#input.addClass("edit-message");
        delete this.#input.dataset.reply;
        this.#input.removeAttribute("itemid");
        this.message_id = message?.id?.substring(1) || true;
        this.handleEvent_input();
    }

    reply(text, message) {
        this.reset;
        this.message_id = true;
        this.#input.itemid = message?.itemid?.substring(1);
        this.#input.addClass("reply-message");
        this.#input.dataset.reference = text;
        this.handleEvent_input();
    }

    #replace(text) {
        const {selectionStart, selectionEnd, selectionDirection} = this.#input;
        this.#input.setRangeText(text || "", selectionStart, selectionEnd, 'end');
    }

    insert(text) {
        const {selectionStart, selectionEnd, selectionDirection} = this.#input;
        this.#input.setRangeText(text || "", selectionStart, selectionEnd, 'end');
        this.#input.focus();
        return this;
    }

    get message() {
        return this.#input.value.trim();
    }

    set message(value) {
        return this.#input.value = value?.trim() || "";
    }


    load(messages) {
        this.initialize(messages);
    }

    initialize(messages, options = {}) {
        if(!(messages instanceof Array)) messages = [messages];
        let last_msg;
        for(const message of messages) {
            let msg;
            switch(typeof message) {
                case "object":
                    msg = this.#receiveMessage(message);
                    break;
                case "string":
                    msg = this.#receiveNotice(message, options);
                    break;
            }
            if(msg) last_msg = msg;
        }
        return last_msg;
    }


    receive(messages, options = {}) {
        if(messages instanceof Array) return messages.forEach(m => this.receive(m, options));
        if(messages?.itemtype === "Reaction") {
            if(typeof Confetti !== undefined) return Confetti(50, {
                message: messages.message.replace(chatConfettiRegex, "$1")
            });
        }
        const last_msg = this.initialize(messages, options);
        if(!last_msg) return;
        // const atEnd = this.#scrollContainer.getBoundingClientRect().height + this.#scrollContainer.scrollTop === this.#scrollContainer.scrollHeight;
        // if(atEnd)

        requestAnimationFrame(() => last_msg.scrollIntoView({block: 'end'}));
    }

    #receiveMessage({itemid, itemtype, message, remove, ...other}) {
        let messageNode = this.querySelector(`[itemid="${itemid}"]`);
        if(remove) return messageNode?.remove();
        if(!messageNode) messageNode = QbMessage({
            itemtype, itemid,
            class: "qb-message hover",
            tabindex: 0
        });
        if(itemid.endsWith(self.user_id)) messageNode.addClass("my-message");
        else if(!messageNode.isConnected) this.addClass("new-message");
        if(!messageNode.isConnected && this.children.length > 1) {
            const sorted = [messageNode, ...this.children].filter(n=>n.itemid).sort((l,h)=>parseInt(l.itemid) - parseInt(h.itemid));
            let reference = this.firstElementChild;
            for (const node of sorted) {
                if (node !== reference?.nextSibling) {
                    this.insertBefore(node, reference?.nextSibling ?? null);
                }
                reference = node;
            }
        }
        if(!messageNode.isConnected) this.append(messageNode);

        const sender_id = itemid.split("_")?.at(1);
        messageNode.update({sender_id, message, ...other});
        return messageNode;
    }

    #receiveNotice(message, options = {}) {
        let {itemtype = "Notice", itemid, remove} = options;
        message = message.toString();
        if(!itemid) itemid = `${itemtype}_${message.hashCode || "0"}`;
        this.#receiveMessage({itemid, itemtype, message, remove});
    }

}

customElements.register(QbChat);


["message", "notice", "warn", "exception", "error"].forEach(type => {
    Reflect.defineProperty(self, type, {
        value(message, options) {
            self.QbChat.receive(message, Object.assign({itemtype: type.replace(/^(.)/, m => m.toUpperCase())}, options));
        }
    });
})
